module.exports = __webpack_public_path__ + "static/img/icon_gujia.464ffa72.png";